import React from "react";
import FJLocalStore from "../../../../store/FJLocalStore";
import styles from './FJFetchError.module.less';
import InlineSVG from "react-inlinesvg";
import ErrorIcon from "../../../../icon/search_empty.svg";
import classNames from 'classnames';

function FJFetchError(props) {
  const {active, onRetry, style = {}} = props;
  return (
    <div className={classNames(styles.fetch_error, {[styles.active]: active})} style={style}>
      <div className={styles.info}>
        <InlineSVG src={ErrorIcon}/>
      </div>
      <span className={styles.error_text}>
				{FJLocalStore._('load-error')}
			</span>
      <span className={styles.text}
            onClick={onRetry}>
				{FJLocalStore._('try-again')}
			</span>
    </div>
  );
}

export default FJFetchError;
